import { Object3D, Vector3 } from 'three';

export class OpenPoseBodyBone {
  /*
   * FIELDS
   */
  name!: string;
  object_start!: Object3D;
  object_end!: Object3D;
  distance!: number;

  /*
   * METHODS
   */

  constructor(name: string, start_object: Object3D, end_object: Object3D, distance: number) {
    this.name = name;
    this.object_start = start_object;
    this.object_end = end_object;
    this.distance = distance;
  }

  get_distance(): number {
    // Return the stored distance (for fixed length constraints)
    return this.distance;
  }

  get_actual_distance(): number {
    // Return the actual distance between objects
    const position_start = new Vector3();
    const position_end = new Vector3();

    this.object_start.getWorldPosition(position_start);
    this.object_end.getWorldPosition(position_end);

    return position_start.distanceTo(position_end);
  }

  set_distance(distance: number): void {
    if (!this.object_start) return;
    if (!this.object_end) return;

    const world_position_start = new Vector3();
    const world_position_end = new Vector3();

    this.object_start.getWorldPosition(world_position_start);
    this.object_end.getWorldPosition(world_position_end);

    const direction = world_position_end.clone().sub(world_position_start);

    if (direction.length() === 0) {
      direction.set(0, -1, 0);
    } else {
      direction.normalize();
    }

    const world_position_new = world_position_start.clone().add(direction.multiplyScalar(distance));

    if (this.object_end.parent) {
      const local_position = this.object_end.parent.worldToLocal(world_position_new.clone());
      this.object_end.position.copy(local_position);
    } else {
      this.object_end.position.copy(world_position_new);
    }

    this.distance = distance;
  }

  update_stored_distance(): void {
    this.distance = this.get_actual_distance();
  }

  set_stored_distance(distance: number): void {
    // Only update the stored distance without moving the node
    this.distance = distance;
  }
}
